export default {
    bindings: {
        link: '=',
        disable: '=',
        multiSelect: '<'
    },
    controller: 'statusesController',
    template: require('../views/payment.statuses.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/components/payment.statuses.component.js